import { createContext } from "react";

const Context = createContext({
  isLoggedIn: false,
  manualRefresh: true,
  loading: true,
  role: {},
  employee: {},
  permission: [],
  employeeData: [],
  sidebar: true,
  access:{}
});

export default Context;
